import basic from './en/basic';

export default {
    test: 'Test',
    basic,
};
